<template>
  <div class="container">
   
    <el-card class="box-card" v-loading="loading">
      <!-- 基本信息 -->
      <el-descriptions title="基本信息" :column="2" border>
        <el-descriptions-item label="姓名">
          {{ talentInfo.name || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="性别">
          {{ getGenderText(talentInfo.gender) }}
        </el-descriptions-item>
        <el-descriptions-item label="年龄">
           <div>{{ calculateYearsFromNow(talentInfo.birth_date) }}岁</div>
        </el-descriptions-item>
        <el-descriptions-item label="手机号码">
          {{ talentInfo.phone || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="电子邮箱">
          {{ talentInfo.email || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="最高学历">
          {{ talentInfo.highest_education || '-' }}
        </el-descriptions-item>
         <el-descriptions-item label="入驻时间">
          {{ talentInfo.create_time || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">
          <div class="remark-container">
            <span v-if="!isEditingRemark">{{ talentInfo.remark || '暂无备注' }}</span>
            <el-input
              v-else
              v-model="tempRemark"
              type="textarea"
              :rows="3"
              placeholder="请输入备注信息"
              maxlength="500"
              show-word-limit
            ></el-input>
            <div class="remark-actions">
              <el-button 
                v-if="!isEditingRemark" 
                type="primary" 
                size="small" 
                @click="startEditRemark"
              >
                编辑备注
              </el-button>
              <template v-else>
                <el-button size="small" @click="cancelEditRemark">取消</el-button>
                <el-button type="primary" size="small" @click="saveRemark" :loading="submitLoading">保存</el-button>
              </template>
            </div>
          </div>
        </el-descriptions-item>
      </el-descriptions>

      <!-- 求职信息 -->
      <el-descriptions title="求职信息" :column="2" border class="mt-20">
         <el-descriptions-item label="工作经验">
           <div>{{ calculateYearsFromNow(talentInfo.job_year) }}年</div>
        </el-descriptions-item>
        <el-descriptions-item label="期望职位">
          {{ talentInfo.expected_position || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="期望薪资">
          {{ talentInfo.expected_salary || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="期望工作地点">
          {{ talentInfo.expected_location || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="求职状态">
          {{talentInfo.job_status || '-'}}
        </el-descriptions-item>
      </el-descriptions>

      <!-- 地址信息 -->
      <el-descriptions title="地址信息" :column="2" border class="mt-20">
        <el-descriptions-item label="所在地区">
          {{ [talentInfo.province, talentInfo.city, talentInfo.district].filter(Boolean).join('-') || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="现居住地">
          {{ talentInfo.address || '-' }}
        </el-descriptions-item>
      </el-descriptions>

      <!-- 工作经历 -->
      <div class="mt-20">
        <div class="section-title">工作经历</div>
        <el-card v-if="!workExperiences || workExperiences.length === 0" class="no-data">
          <div class="text-center">暂无工作经历</div>
        </el-card>
        
        <el-card v-for="(work, index) in workExperiences" :key="index" class="work-card">
          <div class="work-header">
            <div class="work-company">{{ work.company_name }}</div>
            <el-tag size="small" type="primary">{{ work.position }}</el-tag>
          </div>
          
          <div class="work-info">
            <div class="info-item">
              <span class="label">工作时间：</span>
              <span class="value">
                {{ formatDate(work.start_date) }} ~ {{ work.end_date ? formatDate(work.end_date) : '至今' }}
              </span>
            </div>
          </div>
          
          <div class="work-responsibilities" v-if="work.responsibilities">
            <div class="responsibilities-label">工作职责与业绩：</div>
            <div class="responsibilities-content">{{ work.responsibilities }}</div>
          </div>
        </el-card>
      </div>
    </el-card>

    <!-- 返回按钮 -->
    <div class="back-btn-wrapper">
      <el-button @click="goBack">返回列表</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav: { firstNav: "人才管理", secondNav: "人才详情" },
      loading: false,
      isEditingRemark: false,
      submitLoading: false,
      tempRemark: '',
      talentInfo: {
        id: null,
        name: '',
        gender: '',
        birth_date: null,
        phone: '',
        email: '',
        highest_education: '',
        expected_position: '',
        expected_salary: '',
        expected_location: '',
        job_status: '',
        province: '',
        city: '',
        district: '',
        address: '',
        longitude: null,
        latitude: null,
        remark: ''
      },
      workExperiences: []
    };
  },

  mounted() {
    this.getTalentId();
    this.getTalentDetail();
  },

  methods: {

    // 格式化日期
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    // 计算从指定日期到现在有多少年
    calculateYearsFromNow(date) {
      if (!date) return '-';
      const startDate = new Date(date);
      const now = new Date();
      
      let years = now.getFullYear() - startDate.getFullYear();
      const monthDiff = now.getMonth() - startDate.getMonth();
      
      // 如果月份差为负，或者月份相同但日期较小，则减1年
      if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < startDate.getDate())) {
        years--;
      }
      
      return years;
    },
    // 获取人才ID
    getTalentId() {
      const id = this.$route.query.id;
      if (!id) {
        this.$message.error('缺少人才ID参数');
        this.goBack();
        return;
      }
      this.talentInfo.id = id;
    },

    // 获取人才详情
    getTalentDetail() {
      this.loading = true;
      this.$axios({
        url: "/user/talent/queryTalentDetail",
        params: {
          id: this.talentInfo.id
        }
      }).then((res) => {
        this.talentInfo = res.data.data.talent;
         this.workExperiences = res.data.data.workExperiences;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 获取性别文本
    getGenderText(gender) {
      if (gender === 'M') return '男';
      if (gender === 'F') return '女';
      return '-';
    },

    // 开始编辑备注
    startEditRemark() {
      this.tempRemark = this.talentInfo.remark || '';
      this.isEditingRemark = true;
    },

    // 取消编辑备注
    cancelEditRemark() {
      this.isEditingRemark = false;
      this.tempRemark = '';
    },

    // 保存备注
    saveRemark() {
      this.submitLoading = true;
      this.$axios({
        url: "/user/talent/update",
        method: "post",
        data: {
          id: this.talentInfo.id,
          remark: this.tempRemark
        }
      }).then((res) => {
        this.$message.success('备注保存成功');
        this.talentInfo.remark = this.tempRemark;
        this.isEditingRemark = false;
      }).catch((err) => {
        this.$message.error('备注保存失败');
      }).finally(() => {
        this.submitLoading = false;
      });
    },

    // 返回列表
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.mt-20 {
  margin-top: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
}

.no-data {
  text-align: center;
  padding: 30px;
  color: #909399;
}

.text-center {
  text-align: center;
}

.work-card {
  margin-bottom: 15px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.work-header {
  display: flex;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.work-company {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-right: 10px;
}

.work-info {
  margin-bottom: 15px;
}

.info-item {
  margin-bottom: 8px;
  font-size: 14px;
  
  .label {
    color: #909399;
    margin-right: 5px;
  }
  
  .value {
    color: #606266;
  }
}

.work-responsibilities {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px dashed #dcdfe6;
}

.responsibilities-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.responsibilities-content {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}

.back-btn-wrapper {
  margin-top: 20px;
  text-align: right;
}

.remark-container {
  width: 100%;
}

.remark-actions {
  margin-top: 10px;
  text-align: right;
}
</style>
